<template>
  <section>
    <Header :user="user" />
    <main
      class="main animated fadeIn faster"
      :class="{ 'expand-main': isMenuCollapse }"
    >
      <div class="container-fluid py-3">
        <h4 class="mb-3">Audit captcha Mailinblack</h4>
        <p class="text-muted small mb-3">
          Prenez un <strong>échantillon aléatoire</strong> (~30) par opérateur,
          ouvrez l’e-mail avec <strong>Voir l’e-mail</strong> et cliquez vous-même
          sur le lien du captcha pour vérifier s’il est encore actif.
        </p>

        <div class="card p-3 mb-3">
          <div class="form-row align-items-end">
            <div class="form-group col-md-2 mb-2">
              <label class="small mb-1">Du</label>
              <input v-model="filters.from" type="date" class="form-control form-control-sm" />
            </div>
            <div class="form-group col-md-2 mb-2">
              <label class="small mb-1">Au</label>
              <input v-model="filters.to" type="date" class="form-control form-control-sm" />
            </div>
            <div class="form-group col-md-3 mb-2">
              <label class="small mb-1">Opérateur</label>
              <select v-model="filters.user_id" class="form-control form-control-sm">
                <option value="">Tous (captcha resolvers)</option>
                <option v-for="op in operators" :key="op.id" :value="String(op.id)">
                  {{ op.label }}
                </option>
              </select>
            </div>
            <div class="form-group col-md-1 mb-2">
              <label class="small mb-1">Limite</label>
              <input
                v-model.number="filters.limit"
                type="number"
                min="1"
                max="500"
                class="form-control form-control-sm"
              />
            </div>
            <div class="form-group col-md-2 mb-2">
              <div class="custom-control custom-checkbox mt-4">
                <input
                  id="sampleRandom"
                  v-model="filters.sample"
                  type="checkbox"
                  class="custom-control-input"
                />
                <label class="custom-control-label small" for="sampleRandom"
                  >Échantillon aléatoire</label
                >
              </div>
            </div>
            <div class="form-group col-md-2 mb-2">
              <div class="custom-control custom-checkbox mt-4">
                <input
                  id="onlyWithBody"
                  v-model="filters.only_with_body"
                  type="checkbox"
                  class="custom-control-input"
                />
                <label class="custom-control-label small" for="onlyWithBody"
                  >Avec HTML seulement</label
                >
              </div>
            </div>
          </div>
          <div>
            <button class="btn btn-primary btn-sm" :disabled="loading" @click="load">
              {{ loading ? "Chargement…" : "Rechercher" }}
            </button>
          </div>
        </div>

        <div v-if="summary.length" class="card p-2 mb-3">
          <table class="table table-sm table-borderless mb-0">
            <thead>
              <tr>
                <th>Opérateur</th>
                <th>Total done</th>
                <th>Avec HTML</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="row in summary" :key="row.user_id">
                <td>{{ row.user_email || row.user_id }}</td>
                <td>{{ row.total }}</td>
                <td>{{ row.with_body != null ? row.with_body : row.with_link }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div v-if="loading" class="text-muted">Chargement…</div>
        <div v-else-if="!items.length" class="text-muted">Aucun résultat.</div>
        <div v-else class="card">
          <table class="w-100 table table-hover table-sm bg-white mb-0">
            <thead class="thead-dark">
              <tr>
                <th>#</th>
                <th>Done at</th>
                <th>Opérateur</th>
                <th>HTML</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, index) in filteredItems" :key="row.id">
                <td>{{ index + 1 }}</td>
                <td class="small">{{ row.done_at }}</td>
                <td class="small">{{ row.user_email || row.user_id }}</td>
                <td>
                  <span
                    class="badge"
                    :class="hasBody(row) ? 'badge-success' : 'badge-secondary'"
                  >
                    {{ hasBody(row) ? "oui" : "non" }}
                  </span>
                </td>
                <td class="text-nowrap">
                  <button
                    class="btn btn-primary btn-sm"
                    :disabled="!hasBody(row) || loadingBodyId === row.id"
                    @click="openEmail(row)"
                  >
                    {{ loadingBodyId === row.id ? "…" : "Voir l’e-mail" }}
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </main>

    <Modal ref="emailModal" name="antispam-audit-email" size="90" :scrollable="true">
      <div class="p-3">
        <h5 class="mb-2">E-mail antispam</h5>
        <p class="small text-muted mb-2" v-if="modalMeta">
          #{{ modalMeta.id }} · {{ modalMeta.done_at }} · user {{ modalMeta.user_id }}
        </p>
        <p class="small mb-3">
          Cliquez sur le lien du captcha dans l’e-mail pour vérifier s’il est encore actif.
        </p>
        <div v-if="loadingBody" class="text-muted">Chargement du HTML…</div>
        <div v-else-if="!modalHtml" class="alert alert-warning mb-0">
          HTML non disponible (dones antérieurs à la sauvegarde du body, ou body vide).
        </div>
        <iframe
          v-else
          class="antispam-audit-iframe border w-100 bg-white"
          title="Email HTML"
          sandbox="allow-popups allow-popups-to-escape-sandbox allow-same-origin"
          :srcdoc="modalHtmlForIframe"
        ></iframe>
      </div>
    </Modal>
  </section>
</template>

<script>
import { mapState, mapActions } from "vuex";
import Header from "@/components/Header.vue";
import Modal from "@/components/Common/Modal.vue";
import { emailsService } from "@/_services";

const CAPTCHA_OPERATORS = [
  { id: 113385, label: "captcharesolver1 (113385)" },
  { id: 113386, label: "captcharesolver2 (113386)" },
  { id: 113387, label: "captcharesolver3 (113387)" },
  { id: 113388, label: "captcharesolver4 (113388)" },
  { id: 113389, label: "captcharesolver5 (113389)" },
  { id: 2020, label: "pablo (2020)" },
];

function todayStr() {
  const d = new Date();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${d.getFullYear()}-${m}-${day}`;
}

function yesterdayStr() {
  const d = new Date();
  d.setDate(d.getDate() - 1);
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${d.getFullYear()}-${m}-${day}`;
}

/** Force links to open in a new tab so the auditor can click captcha URLs. */
function prepareEmailHtml(html) {
  if (!html) return "";
  let out = String(html);
  // Ensure anchors open in a new tab
  out = out.replace(/<a\b([^>]*)>/gi, (full, attrs) => {
    let a = attrs;
    if (/target\s*=/i.test(a)) {
      a = a.replace(/target\s*=\s*(['"]).*?\1/i, 'target="_blank"');
    } else {
      a += ' target="_blank"';
    }
    if (!/rel\s*=/i.test(a)) {
      a += ' rel="noopener noreferrer"';
    }
    return `<a${a}>`;
  });
  return out;
}

export default {
  name: "AntispamAudit",
  components: { Header, Modal },
  data() {
    return {
      operators: CAPTCHA_OPERATORS,
      filters: {
        from: yesterdayStr(),
        to: todayStr(),
        user_id: "",
        limit: 30,
        sample: true,
        only_with_body: true,
      },
      items: [],
      summary: [],
      loading: false,
      loadingBodyId: null,
      loadingBody: false,
      modalHtml: null,
      modalMeta: null,
    };
  },
  computed: {
    ...mapState({
      isMenuCollapse: (state) => state.sidebar.isNavOpen,
    }),
    user() {
      return this.$store.state.authentication.user;
    },
    filteredItems() {
      if (!this.filters.only_with_body) return this.items;
      return this.items.filter((row) => this.hasBody(row));
    },
    modalHtmlForIframe() {
      return prepareEmailHtml(this.modalHtml);
    },
  },
  mounted() {
    this.udpdateHeader("captcha_audit");
    this.load();
  },
  methods: {
    ...mapActions("headertopbar", {
      setCurrentRoute: "setRoute",
      setCurrentRouteChild: "setRouteChild",
    }),
    udpdateHeader(route) {
      this.setCurrentRoute({ page: route });
      this.setCurrentRouteChild({ child: "" });
    },
    hasBody(row) {
      return row.has_body === true || row.has_body === 1 || row.has_body === "1";
    },
    buildPayload() {
      const payload = {
        from: this.filters.from || null,
        to: this.filters.to || null,
        limit: this.filters.limit || 30,
        sample: !!this.filters.sample,
      };
      if (this.filters.user_id) {
        payload.user_id = Number(this.filters.user_id);
      } else {
        payload.user_ids = this.operators.map((op) => op.id);
      }
      return payload;
    },
    load() {
      this.loading = true;
      emailsService
        .getAntispamAuditList(this.buildPayload())
        .then((result) => {
          this.items = (result && result.items) || [];
          this.summary = (result && result.summary) || [];
        })
        .catch(() => {
          this.items = [];
          this.summary = [];
        })
        .finally(() => {
          this.loading = false;
        });
    },
    openEmail(row) {
      this.loadingBodyId = row.id;
      this.loadingBody = true;
      this.modalHtml = null;
      this.modalMeta = { id: row.id, done_at: row.done_at, user_id: row.user_id };
      this.$refs.emailModal.showModal();
      emailsService
        .getAntispamAuditBody(row.id)
        .then((result) => {
          this.modalHtml = (result && result.body_html) || null;
          if (result) {
            this.modalMeta = {
              id: result.id,
              done_at: result.done_at,
              user_id: result.user_id,
            };
          }
        })
        .catch(() => {
          this.modalHtml = null;
        })
        .finally(() => {
          this.loadingBodyId = null;
          this.loadingBody = false;
        });
    },
  },
};
</script>

<style scoped>
.antispam-audit-iframe {
  min-height: 70vh;
  height: 70vh;
}
</style>
